import {
  __glob
} from "./chunk-HS5PO5ZQ.js";

// import("../plots/**/*.js") in plots/importPlot.js
var globImport_plots_js = __glob({
  "../plots/controls.btns.js": () => import("./controls.btns-6AKLIWOG.js"),
  "../plots/controls.config.js": () => import("./controls.config-353QCQTZ.js"),
  "../plots/controls.js": () => import("./controls-Z4URI2HB.js"),
  "../plots/dictionary.js": () => import("./dictionary-S4MSWVZV.js"),
  "../plots/gb/test/genomeBrowser.spec.js": () => import("./genomeBrowser.spec-6YCQISMJ.js"),
  "../plots/geneExpression.js": () => import("./geneExpression-6JNMJMWW.js"),
  "../plots/geneORA.js": () => import("./geneORA-NWJCROO7.js"),
  "../plots/geneset.js": () => import("./geneset-UODQ45RY.js"),
  "../plots/hierCluster.js": () => import("./hierCluster-W5GMLGYX.js"),
  "../plots/importPlot.js": () => import("./importPlot-CEK76RBM.js"),
  "../plots/matrix.js": () => import("./matrix-KWYUKXMK.js"),
  "../plots/matrix/hierCluster.config.js": () => import("./hierCluster.config-R5TSOJXJ.js"),
  "../plots/matrix/hierCluster.interactivity.js": () => import("./hierCluster.interactivity-5EFMAIWI.js"),
  "../plots/matrix/hierCluster.js": () => import("./hierCluster-36UVKTYM.js"),
  "../plots/matrix/hierCluster.renderers.js": () => import("./hierCluster.renderers-YGX6MZZW.js"),
  "../plots/matrix/matrix.cells.js": () => import("./matrix.cells-5RTZUJVN.js"),
  "../plots/matrix/matrix.cluster.js": () => import("./matrix.cluster-RH4BOM5F.js"),
  "../plots/matrix/matrix.config.js": () => import("./matrix.config-RO3SVOXR.js"),
  "../plots/matrix/matrix.data.js": () => import("./matrix.data-Y5TPRGMW.js"),
  "../plots/matrix/matrix.dom.js": () => import("./matrix.dom-Q5XSAUUH.js"),
  "../plots/matrix/matrix.groups.js": () => import("./matrix.groups-6DXCAY4P.js"),
  "../plots/matrix/matrix.interactivity.js": () => import("./matrix.interactivity-IFAZAA5Z.js"),
  "../plots/matrix/matrix.js": () => import("./matrix-TFFEEDIA.js"),
  "../plots/matrix/matrix.layout.js": () => import("./matrix.layout-YBOMANSO.js"),
  "../plots/matrix/matrix.legend.js": () => import("./matrix.legend-S3E76TVO.js"),
  "../plots/matrix/matrix.renderers.js": () => import("./matrix.renderers-GMFIA6FN.js"),
  "../plots/matrix/matrix.serieses.js": () => import("./matrix.serieses-3UGLZW25.js"),
  "../plots/matrix/matrix.sort.js": () => import("./matrix.sort-A7CNLDUJ.js"),
  "../plots/matrix/matrix.sorterUi.js": () => import("./matrix.sorterUi-6PZR3YOD.js"),
  "../plots/matrix/test/hierCluster.integration.spec.js": () => import("./hierCluster.integration.spec-DWKVGISB.js"),
  "../plots/matrix/test/matrix.integration.spec.js": () => import("./matrix.integration.spec-SVRHEE3X.js"),
  "../plots/matrix/test/matrix.sort.unit.spec.js": () => import("./matrix.sort.unit.spec-OTC5SKDW.js"),
  "../plots/matrix/test/matrix.sorterUi.unit.spec.js": () => import("./matrix.sorterUi.unit.spec-2AJSZUK3.js"),
  "../plots/matrix/test/matrix.unit.spec.js": () => import("./matrix.unit.spec-BHFL7H6D.js"),
  "../plots/matrix/test/oncomatrix.spec.js": () => import("./oncomatrix.spec-MLIE6VVA.js"),
  "../plots/plot.brainImaging.js": () => import("./plot.brainImaging-Y36M3BBW.js"),
  "../plots/plot.disco.js": () => import("./plot.disco-YY3ITSSS.js"),
  "../plots/plot.ssgq.js": () => import("./plot.ssgq-3UGJTTCN.js"),
  "../plots/singleCellPlot.js": () => import("./singleCellPlot-5AAE5QGD.js"),
  "../plots/stattable.js": () => import("./stattable-DJCYOA6Y.js"),
  "../plots/survival/test/survival.integration.spec.js": () => import("./survival.integration.spec-IMLRYIX2.js"),
  "../plots/table.js": () => import("./table-6VZK2B2G.js"),
  "../plots/test/expclust.gdc.spec.js": () => import("./expclust.gdc.spec-S75GMZYG.js"),
  "../plots/test/summary.integration.spec.js": () => import("./summary.integration.spec-PEICP7YJ.js"),
  "../plots/volcano/test/testData.js": () => import("./testData-DRM5HWQB.js")
});

// plots/importPlot.js
async function importPlot(chartType, notFoundMessage = "") {
  switch (chartType) {
    case "aggMatrixInput":
      return await import("./AggMatrixInput-A4EATVXG.js");
    case "aggregateMatrix":
      return await import("./AggregateMatrix-3D36XP7Q.js");
    case "animatedBubbleChart":
      return await import("./animatedBubbleChart-ASVK3MS5.js");
    case "brainImaging":
      return await import("./brainImaging-WNEQQ3RS.js");
    case "brainRegions":
      return await import("./brainRegions-WKCAU4NE.js");
    case "barchart":
      return await import("./barchart-CM3XHZTA.js");
    case "boxplot":
      return await import("./BoxPlot-JNISSUMV.js");
    case "bubbleHeatmap":
      return await import("./bubbleHeatmap-CYHNKNYP.js");
    case "cellTypeBubbleHeatmap":
      return await import("./cellTypeBubbleHeatmap-N6JWAUWC.js");
    case "correlationVolcano":
      return await import("./CorrelationVolcano-BXXFXVHQ.js");
    case "cuminc":
      return await import("./Cuminc-PYG3TJSE.js");
    case "dataDownload":
      return await import("./dataDownload-LJPBW5RL.js");
    case "DEinput":
      return await import("./DEinput-YVXCVTCX.js");
    case "dictionary":
      return await import("./dictionary-S4MSWVZV.js");
    case "differentialAnalysis":
      return await import("./DifferentialAnalysis-TFWK7UE7.js");
    case "Disco":
      return await import("./Disco-PXBROYMP.js");
    case "dmr":
      return await import("./DmrPlot-G3QAPQ5I.js");
    case "facet":
      return await import("./facet-YFLHDE77.js");
    case "GeneExpInput":
      return await import("./GeneExpInput-EYNET6LR.js");
    case "geneRanking":
      return await import("./geneRanking-K6E7MT33.js");
    case "genomeBrowser":
      return await import("./GB-BLGXVCL2.js");
    case "geomap":
      return await import("./Geomap-OTF5DRZT.js");
    case "grin2":
      return await import("./grin2-WN32DXUL.js");
    case "gsea":
      return await import("./GSEA-ZQNLH62K.js");
    case "imagePlot":
      return await import("./imagePlot-BJAQGEBF.js");
    case "numericDictTermCluster":
      return await import("./numericDictTermCluster-6XDVVWLE.js");
    case "profileBarchart2":
      return await import("./barchart2-SC63JKN5.js");
    case "profileForms":
      return await import("./profileForms-53MNCKET.js");
    case "profilePlot":
      return await import("./profilePlot-SPLM6VD4.js");
    case "profilePolar2":
      return await import("./polar2-VK4MADEW.js");
    case "profileRadar2":
      return await import("./radar2-O2HJVBZE.js");
    case "profileRadarFacility2":
      return await import("./radarFacility2-PJHSIHK5.js");
    case "proteinView":
      return await import("./proteinView-ZHNMVSLF.js");
    case "proteomeAbundance":
      return await import("./proteomeAbundance-NH3Y4YC7.js");
    case "proteomeCohortCompare":
      return await import("./proteomeCohortCompare-WGUPOLE3.js");
    case "ProteomeInput":
      return await import("./ProteomeInput-4M2SXSJG.js");
    case "regression":
      return await import("./Regression-GXAACUGA.js");
    case "report":
      return await import("./report-47ASX5AT.js");
    case "runChart2":
    //See frequencyChart
    case "frequencyChart":
      return await import("./RunChart2-ZE7RGJEJ.js");
    case "sampleView":
      return await import("./sampleView-SS5PCWRL.js");
    case "sampleScatter":
      return await import("./scatter-DXGINZED.js");
    case "sc":
      return await import("./SC-4O73EKKZ.js");
    case "studyCatalog":
      return await import("./studyCatalog-TOGQ24WQ.js");
    case "cohortSunburst":
      return await import("./cohortSunburst-HEXOA7M4.js");
    case "summarizeCnvGeneexp":
      return await import("./summarizeCnvGeneexp-6Z3VVSMQ.js");
    case "summarizeGeneexpSurvival":
      return await import("./summarizeGeneexpSurvival-REIPWAEJ.js");
    case "summarizeMutationDiagnosis":
      return await import("./summarizeMutationDiagnosis-PVOTM3DF.js");
    case "summarizeMutationSurvival":
      return await import("./summarizeMutationSurvival-X7TV3EKS.js");
    case "summarizeMutationCnv":
      return await import("./summarizeMutationCnv-OJNIJR55.js");
    case "summaryInput":
      return await import("./summaryInput-53MQOUXV.js");
    case "summary":
      return await import("./summary-RNNIEEHQ.js");
    case "sunburst":
      return await import("./sunburst-MYKDYBVD.js");
    case "swimmer":
      return await import("./swimmer-HO32NUCE.js");
    case "survival":
      return await import("./survival-3IECSQKM.js");
    case "table":
      return await import("./table-6VZK2B2G.js");
    case "violin":
      return await import("./Violin-AR74D2S5.js");
    case "volcano":
      return await import("./Volcano-NC6CM3FY.js");
    case "wsi":
      return await import("./Wsi-AR2WRIQO.js");
    default:
      if (notFoundMessage) throw notFoundMessage;
      return await globImport_plots_js(`../plots/${chartType}.js`);
  }
}

export {
  importPlot
};
//# sourceMappingURL=chunk-KZXFNO75.js.map
